<template>
	<div id="editPass">
		<Layout>
			<Header :style="{ position: 'fixed', width: '100%' }">
				<div class="headerInner">
					<Row>
						<Col span="5">
						<div class="headerInnerLogo">
							<router-link to="/">
								<img src="../../assets/img/logo.png" />
							</router-link>
						</div>
						</Col>
						<Col span="13">
						<div class="headerInnerName">
							<h1>密码修改</h1>
						</div>
						</Col>
					</Row>
				</div>
			</Header>
			<Content class="contentMain" :style="{height: mainHigh+'px'}">
				<div class="forgetPass">
					<div style="width: 400px;margin: 0 auto;padding-top: 50px;">
						<Form ref="ePasForm" :model="ePasForm" :rules="ruleValidate" :label-width="100" size="large">
							<FormItem label="用户昵称">
								<span class="ePasFormSpan">{{ePasForm.sName}}</span>
							</FormItem>
							<FormItem label="手机号码">
								<span class="ePasFormSpan">{{ePasForm.sPhone}}</span>
							</FormItem>
							<FormItem label="短信验证码">
								<Input size="large" v-model="ePasForm.sDXCode" placeholder="输入短信验证码"
									class="codeInput"></Input>
								<Button type="primary" ghost class="codeBtn" @click="getCode" size="large"
									:disabled="isgain">{{codeText}}</Button>
							</FormItem>
							<FormItem label="新密码">
								<Input size="large" v-model="ePasForm.sPwd" type="password"
									placeholder="密码 8-18位且必须包含字母和数字"></Input>
							</FormItem>
							<FormItem label="确认密码">
								<Input size="large" v-model="ePasForm.sPwdAgain" type="password"
									placeholder="再次输入密码"></Input>
							</FormItem>
							<FormItem label="验证码" class="verifyCode">
								<Input size="large" v-model="ePasForm.sTXCode" placeholder="输入图形验证码"
									class="codeInput"></Input>
								<div class="codeImg" id="signCode"></div>
							</FormItem>
							<FormItem>
								<Button type="primary" style="background-color:#115467;" size="large" long @click="ePasSubmit"
									:loading="loading">提交修改</Button>
							</FormItem>
						</Form>
					</div>

				</div>
			</Content>
			<Footer>
				<pageFoot></pageFoot>
			</Footer>
		</Layout>
	</div>
</template>
<script>
	import pageFoot from '../../components/pageFoot/footer.vue';
	import {
		getToken,
		logOut,

	} from '../../libs/util.js';
	import {
		userAuthCode,
		userCode,
		userEditPass,
		userOut
	} from '../../request/api.js';
	import {
		encrypt
	} from '../../libs/rsaEncrypt.js';
	import {
		GVerify
	} from '../../libs/verifyCode.js';
	export default {
		name: 'userCenter',
		components: {
			pageFoot,
		},
		data() {
			const validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('密码不为空'));
				} else {
					var pattern = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？ ]");
					if (value.length < 8) {
						return callback(new Error('密码不能少于8位！'));
					} else if (value.length > 18) {
						return callback(new Error('密码最长不能超过18位！'));
					} else if (pattern.test(value)) {
						return callback(new Error('密码不能包含特殊字符'));
					} else {
						if (this.ePasForm.sPwdAgain !== '') {
							// 对第二个密码框单独验证
							this.$refs.ePasForm.validateField('sPwdAgain');
						}
						callback()
					}
				}
			};
			const validatePassCheck = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入密码'));
				} else if (value !== this.ePasForm.sPwd) {
					callback(new Error('两次密码不一致!'));
				} else {
					callback();
				}
			};
			const validateTXCode = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('图形验证码不为空'));
				} else {
					var verifyFlag = this.verify.validate(value);
					if (!verifyFlag) {
						callback(new Error('图形验证码错误!'));
						this.verify.refresh()
					} else {
						callback();
					}
				}
			};
			return {
				mainHigh: 0,
				verify: null,
				codeUrl: '',
				isgain: false,
				codeText: '获取验证码',
				timer: null,
				ePasForm: {
					sName: '',
					sPhone: '',
					sDXCode: '',
					sPwd: '',
					sPwdAgain: '',
					sTXCode: '',
					UUid: '',
					txCode: ''
				},
				ruleValidate: {
					sDXCode: [{
						required: true,
						message: '短信验证码不为空',
						trigger: 'blur'
					}],
					sPwd: [{
						required: true,
						validator: validatePass,
						trigger: 'blur'
					}],
					sPwdAgain: [{
						required: true,
						validator: validatePassCheck,
						trigger: 'blur'
					}],
					sTXCode: [{
						required: true,
						validator: validateTXCode,
						trigger: 'blur'
					}],
				},
				loading: false
			}
		},
		methods: {
			getCode() {
				const TIME_COUNT = 60;
				userCode(this.ePasForm.sPhone).then(res => {
					if (res.status == undefined) {
						this.$Message.success('短信验证码发送成功!');
						this.ePasForm.UUid = res;
						if (!this.timer) {
							this.isgain = true;
							this.codeText = TIME_COUNT;
							this.timer = setInterval(() => {
								if (this.codeText > 0 && this.codeText <= TIME_COUNT) {
									this.codeText--;
								} else {
									this.isgain = false;
									this.codeText = '重新获取';
									clearInterval(this.timer);
									this.timer = null;
								}
							}, 1000)
						}
					} else {
						this.$Message.error(res.message);
					}
				})
			},
			ePasSubmit() {
				this.loading = true;
				this.$refs.ePasForm.validate((valid) => {
					if (valid) {
						let editData = {
							code: this.ePasForm.sDXCode,
							password: encrypt(this.ePasForm.sPwd),
							username: this.ePasForm.sPhone,
							uuid: this.ePasForm.UUid
						}
						userEditPass(editData).then(res => {
							this.loading = false;
							this.$Message.success('修改成功，请重新登录！');
							userOut().then(res => {
								logOut();
								setTimeout(() => {
									this.$router.push({
										path: '/login'
									})
								}, 1000)
							})
						}).catch((err) => {
							this.loading = false;
							this.$Message.error(err.message);
						})
					} else {
						this.loading = false;
						this.$Message.error('必填项不可为空!');
					}
				})
			},
		},
		mounted() {
			var h = document.documentElement.clientHeight || document.body.clientHeight;
			this.mainHigh = h - 64 - 172;
			const u = this.$store.state.userDetails;
			if (!u) {
				this.$router.push({
					path: '/'
				})
			} else {
				this.ePasForm.sName = u.nickname;
				this.ePasForm.sPhone = u.loginName;
				this.verify = new GVerify('signCode')
			}

		},
		watch: {}
	}
</script>

<style>
	.ivu-layout-header {
		background: #FFF;
		padding: 0;
		height: 64px;
		line-height: 64px;
		z-index: 99;
	}

	.ivu-menu-horizontal.ivu-menu-light:after {
		display: none;
	}

	.ivu-layout-footer {
		padding: 0;
	}

	.contentMain {
		width: 1200px;
		margin: 64px auto 0;
		padding: 20px 0;
	}

	.headerInner {
		width: 1200px;
		margin: 0 auto;
	}

	.headerInnerName {
		line-height: 44px;
	}

	.headerInnerName h1 {
		font-weight: 400;
	}

	.forgetPass {
		background-color: #FFFFFF;
		padding: 20px;
		height: 100%;
	}

	.ePasFormSpan {
		line-height: 34px;
	}

	.verifyCode .ivu-form-item-content {
		display: flex !important;
		flex-direction: inherit;
		align-items: center;
		justity-content: center;
	}

	.verifyEnter {
		width: 60%;
	}

	.codeInput {
		width: 60%;
	}

	.codeBtn {
		width: 39%;
		margin-left: 1%;
	}

	.codeImg {
		height: 42px;
		width: 39%;
		display: inline-block;
		overflow: hidden;
		margin-left: 1%;
	}
</style>
